import {
  GET_ACTIVITY_MODULES,
  GET_RECENT_ACTIVITIES,
  GET_ACTIVITY_BY_FILTER,
  GET_VOICE_CALLS,
} from 'actions/admin/activities';

const initialState = {
  modules: [],
  recentActivities: [],
  filterActivities: [],
  voiceCallData: {},
};

export default function activities(state = initialState, action = {}) {
  switch (action.type) {
    case GET_ACTIVITY_MODULES: {
      return { ...state, modules: action?.modules };
    }
    case GET_RECENT_ACTIVITIES: {
      return {
        ...state,
        recentActivities: action.recentActivities,
      };
    }
    case GET_ACTIVITY_BY_FILTER: {
      return {
        ...state,
        filterActivities: action?.filterActivities,
      };
    }
    case GET_VOICE_CALLS: {
      return {
        ...state,
        voiceCallData: action.voiceCalls,
      };
    }
    default:
      return state;
  }
}
